import { CHECKLIST, TOUR } from '../navigation';
import { fromMode } from '../navigation/routing';

const mapLink = (pathname = '') => {
  return pathname.includes(`/${TOUR}`) ? fromMode(pathname, `/${CHECKLIST}`) : pathname;
};

const PROPERTY_MAP = {
  link: mapLink
};

export const mapCoachButton = (button = {}) => {
  const accumulator = {};

  for (const key of Object.getOwnPropertyNames(button)) {
    const mapper = PROPERTY_MAP[key];
    const value = button[key];

    accumulator[key] = mapper ? mapper(value) : value;
  }

  return accumulator;
};
